import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

const PinnedDialog = {
  "& .MuiDialog-paper": {
    maxWidth: "800px",
    borderRadius: "12px",
    position: "relative",
    pt: "25px",
    background: "#FFFFFF",
    "&:before": {
      // background: 'linear-gradient(145.45deg, #FFEC9A -130.81%, #CCF0EB 50.06%, #00B2FF 188.34%)',
      width: "100%",
      height: "100%",
      content: '""',
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      borderRadius: "32px",
      position: "absolute",
      top: "0",
      left: "0",
      transform: "rotate(180deg)",
    },
    "&:after": {
      // background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.8) 50%, rgba(255, 255, 255, 0.6) 100%)',
      width: "100%",
      height: "100%",
      content: '""',
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      borderRadius: "32px",
      position: "absolute",
      top: "0",
      left: "0",
      transform: "rotate(180deg)",
    },
  },
  "& .MuiDialogTitle-root": {
    position: "relative",
    zIndex: 1,
    p: "0px 24px 12px 24px",
  },
  "& .MuiDialogContent-root": {
    position: "relative",
    zIndex: 1,
    p: "0px 20px 24px 20px",
    // height: 'calc(100vh - 225px)',
    // '&::-webkit-scrollbar': {
    //     width: '6px',
    // },
    // '&::-webkit-scrollbar-track': {
    //     backgroundColor: 'transparent',
    // },

    // '&::-webkit-scrollbar-thumb': {
    //     backgroundColor: '#D9E1E7',
    //     borderRadius: '8px',
    // },
  },
};

const DialogTitles = {
    color: '#1A2025',
    fontSize: '18px',
    lineHeight: '140%',
    fontWeight: 600,
}

const deleteBtn = {
    fontSize: '14px',
    lineHeight: '140%',
    color: '#fff',
    background: '#931618',
    borderRadius: '30px',
    height: '44px',
    p: '0 20px',
    textTransform: 'capitalize',
    fontWeight: 400,
}
const CancelBtn = {
    fontSize: '14px',
    lineHeight: '140%',
    color: '#0066CC',
    background: '#fff',
    border: '1px solid #0066CC',
    borderRadius: '30px',
    height: '44px',
    p: '0 20px',
    textTransform: 'capitalize',
    fontWeight: 400,
}

function DeleteChatDialog({ open,
    onClose,
    onConfirm,
    chatName,
    title,
    description,
    confirmText = "Delete",
    cancelText = "Cancel" }) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth sx={PinnedDialog}>
            <DialogTitle display='flex' justifyContent='space-between' alignItems='center'>
                <Typography sx={DialogTitles}> {title || `Are you sure you want to delete "${chatName}"?`} </Typography>
            </DialogTitle>

            <DialogContent>
                <Typography fontSize="14px">{description || "This action cannot be undone."}</Typography>
                <DialogActions sx={{ p: 0 }}>
                    <Button onClick={onConfirm} sx={deleteBtn}>
                        {confirmText}
                    </Button>
                    <Button onClick={onClose} sx={CancelBtn}>
                        {cancelText}
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
}

export default DeleteChatDialog;
